import { Button } from "../Button";

interface PillOption<T extends string> {
  value: T;
  label: string;
}

interface PillChoiceProps<T extends string> {
  label: string;
  options: PillOption<T>[];
  value: T | undefined;
  onChange: (value: T) => void;
}

export function PillChoice<T extends string>({
  label,
  options,
  value,
  onChange,
}: PillChoiceProps<T>) {
  return (
    <div role="radiogroup" aria-label={label}>
      <div className="mb-2 text-sm font-medium">{label}</div>
      <div className="flex flex-wrap gap-2">
        {options.map((opt) => (
          <Button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={value === opt.value}
            variant={value === opt.value ? "primary" : "secondary"}
            size="sm"
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
